import type { ChatMonitor } from "@/lib/chat";

/**
 * モニター一覧のうち詳細を表示するモニターの id を決める。選択中のモニターが一覧から
 * 消えた場合 (チャット切替など) は先頭へ寄せる。
 */
export function resolveSelectedMonitorId(
	monitors: ChatMonitor[],
	selectedId: string | null,
): string | null {
	if (selectedId !== null && monitors.some((monitor) => monitor.id === selectedId)) {
		return selectedId;
	}
	return monitors[0]?.id ?? null;
}
